export const CONFIG = {
  /*local url */
//  API_URL: "http://localhost:3001/",
//   LOGIN_URL: "http://localhost:3000",
//   UI_URL: "http://localhost:3000",

  /*Staging url*/
  UI_URL: "https://dev.faretrack.ai",
  API_URL: "https://dev.faretrack.ai/api",
  LOGIN_URL: "https://dev.faretrack.ai",
  AIRLINES_URL: "https://jq2vq4junk.execute-api.us-west-2.amazonaws.com/staging/getallairlinesbyroutesiata",
  RESOURCE_URL: "https://sandbox.faretrack.ai/resources/?rest_route=/wp/v2/posts&_embed=1&per_page=3&_fields=title,date,excerpt,link,_links.wp:term,_links.wp:featuredmedia",
  
// -------------------------------------------------------------------------------------------------------------  
  
  
  /*Live url*/
  //Live for wordpress (Resources)
  // AIRLINES_URL: "https://jq2vq4junk.execute-api.us-west-2.amazonaws.com/staging/getallairlinesbyroutesiata",
  // RESOURCE_URL: "https://www.faretrack.ai/resources/?rest_route=/wp/v2/posts&_embed=1&per_page=3&_fields=title,date,excerpt,link,_links.wp:term,_links.wp:featuredmedia",
  // Wordpress site ui url(dashboard)
  // UI_URL: "https://www.faretrack.ai",
  // API_URL: "https://dashboard.faretrack.ai/api/",
  // LOGIN_URL: "https://dashboard.faretrack.ai"
};

export const DASHBOARD_RESTRICTED_USERS = ["airasiamove@faretrack.ai", "test@expectedcallcount.com", "greg.tarniowy@arajet.com"]
